import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setApiJson } from '../../redux/Actions/ApiAction';

const DateTimePicker = ({
    title = "Scheduled Date & Time",
    name = "scheduledDateTime",
    important = false,
    error = null
}) => {
    const dispatch = useDispatch();
    const ApiReducer = useSelector((state) => state.ApiReducer);
    
    // Get current datetime value from redux and convert timestamp back to datetime-local format
    const getCurrentValue = () => {
        const timestamp = ApiReducer?.apiJson?.[name];
        if (timestamp) {
            const date = new Date(timestamp);
            return date.toISOString().slice(0, 16);
        }
        return '';
    };
    
    const currentValue = getCurrentValue();
    
    // Get minimum datetime (current datetime + 5 minutes)
    const getMinDateTime = () => {
        const now = new Date();
        now.setMinutes(now.getMinutes() + 5);
        return now.toISOString().slice(0, 16);
    };

    const handleDateTimeChange = (e) => {
        const selectedDateTime = e.target.value;
        
        if (selectedDateTime) {
            const dateTime = new Date(selectedDateTime);
            const timestamp = dateTime.getTime();
            
            const updatedJson = {
                ...ApiReducer?.apiJson,
                [name]: timestamp // Save timestamp directly to the name field
            };
            
            dispatch(setApiJson(updatedJson));
        } else {
            // Clear timestamp if input is cleared
            const updatedJson = {
                ...ApiReducer?.apiJson,
                [name]: null
            };
            
            dispatch(setApiJson(updatedJson));
        }
    };

    return (
        <div className="flex flex-col">
            <label className="block text-sm font-medium text-gray-700 mb-2">
                {title}
                {important && <span className="text-red-500 ml-1">*</span>}
            </label>
            
            <input
                type="datetime-local"
                name={name}
                value={currentValue}
                onChange={handleDateTimeChange}
                min={getMinDateTime()}
                className={`
                    w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                    ${error ? 'border-red-500' : 'border-gray-300'}
                `}
            />
            
            {error && (
                <span className="text-red-500 text-sm mt-1">{error}</span>
            )}
        </div>
    );
};

export default DateTimePicker;